import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface User {
  id: number;
  usuario: string;
  nombre?: string;
  email?: string;
  role?: string;
  rolId?: number | null;
  rol?: {
    id: number;
    nombre: string;
  } | null;
  activo?: boolean;
}

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (user: User, token: string) => void;
  logout: () => void;
  setLoading: (loading: boolean) => void;
  checkAuth: () => Promise<void>;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      isLoading: false,
      
      login: (user, token) => {
        const isEnvioRole = user?.rol?.nombre === 'Envíos' || user?.role === 'envios' || user?.rolId === 2;
        const storage = isEnvioRole ? localStorage : sessionStorage;
        
        storage.setItem('auth_token', token);
        storage.setItem('auth_user', JSON.stringify(user));
        localStorage.setItem('user_role', isEnvioRole ? 'repartidor' : 'admin');
        
        set({
          user,
          token,
          isAuthenticated: true,
          isLoading: false,
        });
      },
      
      logout: () => {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('auth_user');
        localStorage.removeItem('user_role');
        sessionStorage.removeItem('auth_token');
        sessionStorage.removeItem('auth_user');
        
        set({
          user: null,
          token: null,
          isAuthenticated: false,
          isLoading: false,
        });
      },
      
      setLoading: (loading) =>
        set({ isLoading: loading }),
      
      checkAuth: async () => {
        const userRole = localStorage.getItem('user_role');
        
        let token = null;
        let userStr = null;
        
        if (userRole === 'repartidor') {
          token = localStorage.getItem('auth_token');
          userStr = localStorage.getItem('auth_user');
        } else {
          token = sessionStorage.getItem('auth_token');
          userStr = sessionStorage.getItem('auth_user');
        }
        
        if (!token || !userStr) {
          if (userRole === 'admin') {
            sessionStorage.removeItem('auth_token');
            sessionStorage.removeItem('auth_user');
          }
          
          set({
            user: null,
            token: null,
            isAuthenticated: false,
          });
          return;
        }
        
        try {
          const user = JSON.parse(userStr);
          set({
            token,
            user,
            isAuthenticated: true,
          });
        } catch {
          set({
            user: null,
            token: null,
            isAuthenticated: false,
          });
        }
      },
    }),
    {
      name: 'auth-storage',
      storage: {
        getItem: (name) => {
          let value = localStorage.getItem(name);
          if (!value) {
            value = sessionStorage.getItem(name);
          }
          return value ? JSON.parse(value) : null;
        },
        setItem: (name, value) => {
          const userRole = localStorage.getItem('user_role');
          if (userRole === 'repartidor') {
            localStorage.setItem(name, JSON.stringify(value));
          } else {
            sessionStorage.setItem(name, JSON.stringify(value));
          }
        },
        removeItem: (name) => {
          localStorage.removeItem(name);
          sessionStorage.removeItem(name);
        },
      },
    }
  )
);